import { gpCommon } from '../app';
import { DurationUnitsType, DurationWithUnit } from '../util/duration-converter';
import { parseFloatSafe, toTwoDecimalPlaces } from '../util/number-helper';

gpCommon.filter('readonlyNumber', ['$filter', function ($filter: ng.IFilterService) {
    return function (input: number) {
        return $filter("number")(input);
    };
}]);

gpCommon.filter('toTwoDecimalPlaces', function () {
    return toTwoDecimalPlaces;
});

const units_Minutes = ["m", "min", "mins", "minute", "minutes"];
const units_Hours = ["h", "hr", "hrs", "hour", "hours"];
const units_Days = ["d", "ds", "day", "days"];
const units_Weeks = ["w", "wk", "wks", "week", "weeks"];
const units_Months = ["mon", "mnth", "mnths", "month", "months"];

const units_lookup = new Map<string, DurationUnitsType>();

for (const unit of units_Minutes) { units_lookup.set(unit, 'minutes') }
for (const unit of units_Hours) { units_lookup.set(unit, 'hours') }
for (const unit of units_Months) { units_lookup.set(unit, 'months') }
for (const unit of units_Days) { units_lookup.set(unit, 'days') }
for (const unit of units_Weeks) { units_lookup.set(unit, 'weeks') }




gpCommon.filter('formatTimeUnitShort', function () {
    return function (input: any) {

        if (typeof input === 'string') {
            const unitStr = input;
            const unit = units_lookup.get(unitStr);

            if (unit) {
                if (unit === 'minutes') {
                    return `m`;
                } else if (unit === 'hours') {
                    return `hr`;
                } else if (unit === 'days') {
                    return `d`;
                } else if (unit === 'weeks') {
                    return `wk`;
                } else if (unit === 'months') {
                    return `mnth`;
                } else {
                    const n: never = unit;
                    throw new Error("Not implemented");
                }
            } else {
                return input;
            }
        } else {
                return input;
        }
          
    };
});


gpCommon.filter('formatDurationShort', function () {
    return function (input: any) {

        if (typeof input === 'object') {
            let amount: number = 0;
            if ('amount' in input) {
                amount = parseFloatSafe(input['amount']) || 0;
            } else if ('work' in input) {
                amount = parseFloatSafe(input['work']) || 0;
            } else if ('duration' in input) {
                amount = parseFloatSafe(input['duration']) || 0;
            } else {
                return input;
            }

            let unitStr: string;

            if ('unit' in input) {
                unitStr = `${input['unit']}`.toLowerCase();
            } else if ('units' in input) {
                unitStr = `${input['units']}`.toLowerCase();
            } else {
                return toTwoDecimalPlaces(amount);
            }

            const unit = units_lookup.get(unitStr);

            const pluralSuffix = (Math.abs(amount - 1) < 0.0001) ? "" : "s";

            if (unit) {
                let result = toTwoDecimalPlaces(amount);
                if (unit === 'minutes') {
                    return `${result} m`;
                } else if (unit === 'hours') {
                    return `${result} hr` + pluralSuffix;
                } else if (unit === 'days') {
                    return `${result} d`;
                } else if (unit === 'weeks') {
                    return `${result} wk` + pluralSuffix;
                } else if (unit === 'months') {
                    return `${result} mnth` + pluralSuffix;
                } else {
                    const n: never = unit;
                    throw new Error("Not implemented");
                }

            } else {
                return toTwoDecimalPlaces(amount);
            }
        } else {
            return input;
        }
    };
});


gpCommon.filter('formatDurationReallyShort', function () {
    return function (input: any) {

        if (typeof input === 'object') {
            let amount: number = 0;
            if ('amount' in input) {
                amount = parseFloatSafe(input['amount']) || 0;
            } else if ('work' in input) {
                amount = parseFloatSafe(input['work']) || 0;
            } else if ('duration' in input) {
                amount = parseFloatSafe(input['duration']) || 0;
            } else {
                return input;
            }

            let unitStr: string;

            if ('unit' in input) {
                unitStr = `${input['unit']}`.toLowerCase();
            } else if ('units' in input) {
                unitStr = `${input['units']}`.toLowerCase();
            } else {
                return toTwoDecimalPlaces(amount);
            }

            const unit = units_lookup.get(unitStr);

            if (unit) {
                let result = toTwoDecimalPlaces(amount);
                if (unit === 'minutes') {
                    return `${result} m`;
                } else if (unit === 'hours') {
                    return `${result} h`;
                } else if (unit === 'days') {
                    return `${result} d`;
                } else if (unit === 'weeks') {
                    return `${result} w`;
                } else if (unit === 'months') {
                    return `${result} mn`;
                } else {
                    const n: never = unit;
                    throw new Error("Not implemented");
                }

            } else {
                return toTwoDecimalPlaces(amount);
            }
        } else {
            return input;
        }
    };
});
